import { render, staticRenderFns } from "./Salesmen.vue?vue&type=template&id=62dc1395&"
import script from "./Salesmen.vue?vue&type=script&lang=js&"
export * from "./Salesmen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports